import { Intro } from 'components/commons';
import React from 'react';

const DashboardModule = () => {
  return (
    <div>
      <div>
        <Intro title={'Dashboard'} subtitle={'Accessing a comprehensive overview of transactions and revenue'} />
      </div>
    </div>
  );
};

export default DashboardModule;
